import ztComponent from './ztRadioButton.vue'
export default Vue => {
  Vue.component(ztComponent.name, ztComponent)
}
